document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll(
    '.custom-collapsible-section .accordion details, .page-faq-container .page-faq-box details'
  );
  

  accordions.forEach((details) => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.accordion__content');

    summary.addEventListener('click', (e) => {
      e.preventDefault();

      if (details.classList.contains('is-animating')) return;

      if (details.open) {
        closeAccordion(details, content);
      } else {
        openAccordion(details, content);
      }
    });
  });

  function openAccordion(details, content) {
    details.classList.add('is-animating');
    details.open = true;

    const endHeight = content.scrollHeight;
    content.style.overflow = 'hidden';

    const animation = content.animate(
      [{ height: '0px' }, { height: endHeight + 'px' }],
      { duration: 300, easing: 'ease' }
    );

    animation.onfinish = () => {
      content.style.overflow = '';
      content.style.height = '';
      details.classList.remove('is-animating');
    };
  }

  function closeAccordion(details, content) {
    details.classList.add('is-animating');

    const startHeight = content.scrollHeight;
    content.style.overflow = 'hidden';

    const animation = content.animate(
      [{ height: startHeight + 'px' }, { height: '0px' }],
      { duration: 300, easing: 'ease' }
    );

    animation.onfinish = () => {
      details.open = false;
      content.style.overflow = '';
      content.style.height = '';
      details.classList.remove('is-animating');
    };
  }
});